/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck — Relay-generated types from duet-network-theverge; CSK compile succeeds without building that app first.
import { ZEPHR_DATA_CONTAINER_CONCRETE_REQUEST } from "@src/utils/csk-query-concrete-requests";
import { FunctionComponent, useEffect, useState } from "react";
import { Environment, fetchQuery, useRelayEnvironment } from "react-relay";

import { cskQueryZephrDataContainerQuery } from "@src/__generated__/relay/cskQueryZephrDataContainerQuery.graphql";
import Zephr, {
  Props as ZephrProps,
} from "@voxmedia/duet-framework/entitlements/Zephr";

interface Props extends ZephrProps {
  refresh?: boolean;
}

const refreshCategoryData = async ({
  environment,
  articleId,
}: {
  environment: Environment;
  articleId: string;
}) => {
  return await fetchQuery<cskQueryZephrDataContainerQuery>(
    environment,
    ZEPHR_DATA_CONTAINER_CONCRETE_REQUEST,
    {
      articleId,
    },
  ).toPromise();
};

const ZephrDataContainer: FunctionComponent<Props> = ({
  refresh = false,
  articleId,
  internalCategories,
  categories,
}) => {
  const [refreshedInternalCategories, setRefreshedInternalCategories] =
    useState<Props["internalCategories"] | null>(null);
  const [refreshedCategories, setRefreshedCategories] = useState<
    Props["categories"] | null
  >(null);

  const environment = useRelayEnvironment();

  useEffect(() => {
    if (!refresh) {
      return;
    }

    refreshCategoryData({ articleId, environment })
      .then((data) => {
        if (!data?.node) {
          return;
        }
        if (data.node.categories) {
          setRefreshedCategories(data.node.categories);
        }
        if (data.node.internalCategories) {
          setRefreshedInternalCategories(data.node.internalCategories);
        }
      })
      .catch(() => {
        console.error("Could not refresh category data");
      });
  }, [refresh, environment, articleId]);

  const resolvedCategories = refreshedCategories ?? categories;
  const resolvedInternalCategories =
    refreshedInternalCategories ?? internalCategories;

  if (!refresh) {
    return (
      <Zephr
        articleId={articleId}
        internalCategories={internalCategories}
        categories={categories}
      />
    );
  }

  return (
    <Zephr
      articleId={articleId}
      internalCategories={resolvedInternalCategories}
      categories={resolvedCategories}
    />
  );
};

export default ZephrDataContainer;
